import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {ContentStyled} from '../../styles/components/content.style';
import {H2} from '../../styles/components/typography.style';

export const ContentWrapper = ContentStyled.extend`
  background: ${props => props.theme.tableBookingPage.backgroundColor};
  text-align: left;
  width: ${props => props.theme.tableBookingPage.width};
  margin-top: ${props => props.theme.tableBookingPage.offsetTop};
  padding-bottom: 1.2rem;
  ${media.medium`
    width: 100%;
  `};
  ${media.small`
    margin: 0;
  `};
`;

export const Title = H2.extend`
  margin-top: ${props => props.theme.margin};
  color: ${p => p.theme.tableBookingPage.color};
  font-weight: ${p => p.theme.tableBookingPage.title.fontWeight};
  text-align: left;
`;

export const Subtitle = styled.span`
  font-size: ${props => props.theme.tableBookingPage.fontSize};
  color: ${p => p.theme.tableBookingPage.color};
`;

export const Form = styled.div`
  background-color: ${props => props.theme.primaryBackground};
  padding: ${props => props.theme.tableBookingPage.padding};
  margin-top: ${props => props.theme.margin};
`;



// WEBPACK FOOTER //
// ./containers/TableBooking/TableBookingPage.style.js